import { EventBus } from "../../../eventbus";
import { baseUrl } from "../../../config";
import { userHasAllRights } from "../../../functions/userRights";
import i18n from "../../../functions/i18next";
import { errorDispatch } from "../../../functions/errorDispatch";
import { copy, paste } from "../../../functions/copyPaste";

export default {
  props: {
    itemData: Object,
  },
  /**
   * Defines the data used by the component
   */
  data() {
    return {
      user: this.$store.state.user,
      company: this.$store.state.company,
      parentFolder: {},
      filesSelected: [],
      foldersSelected: [],
      more: "",
      delete_selection: true,
      move_selection: true,
      copy_selection: true,
      pasting: false,
      buttons: {},
      header: {},
      mySpace: 0,
    };
  },
  created() {
    this.mySpace = this.itemData.mySpace;

    this.checkType(this.itemData);
  },
  methods: {
    checkType(data) {
      this.filesSelected = this.$store.state.transferItems.selectedFiles;
      this.foldersSelected = this.$store.state.transferItems.selectedFolders;

      this.$axios
        .get(baseUrl + "/folderdetail?folder=" + data.folderId)
        .then((response) => {
          this.parentFolder = response.data;

          if (
            this.foldersSelected.length === 0 &&
            this.filesSelected.length === 0
          ) {
            //no files are selected so add the current folder to the selected folders and continue
            //set to use parent btns
            this.more = "parent";

            //set header
            this.header = {
              title: this.parentFolder.name,
              icon: "folder--open",
            };
          } else if (
            this.foldersSelected.length === 0 &&
            this.filesSelected.length === 1
          ) {
            this.more = "onlyFile";

            //set header
            this.header = {
              title: this.filesSelected[0].name,
              icon: "file--simple",
            };
          } else if (
            this.foldersSelected.length === 1 &&
            this.filesSelected.length === 0
          ) {
            this.more = "onlyFolder";

            //set header
            this.header = {
              title: this.foldersSelected[0].name,
              icon: "folder--open",
            };
          } else {
            //is selection
            this.more = "selection";

            //set header
            this.header = false;
          }

          this.setupBtns();
        });
    },
    setupBtns() {
      this.buttons = {
        parent: [
          {
            name: i18n.t("files.rename_folder"),
            icon: "rename",
            func: () => this.openRightSidebar("rename", this.parentFolder),
            rights: ["rename_folders"],
            display: true,
          },
          {
            name: i18n.t("files.move_folder"),
            icon: "move",
            func: () => this.openRightSidebar("move", this.parentFolder),
            rights: ["move_folders"],
            display: true,
          },
          {
            name: !this.parentFolder.private
              ? i18n.t("files.make_private")
              : i18n.t("files.make_public"),
            icon: "makeprivate",
            func: () => this.private(this.parentFolder.id),
            rights: ["make-private_folders"],
            display: true,
          },
          {
            name: i18n.t("common.paste"),
            icon: "paste",
            func: () => this.pasteClipBoard(),
            rights: ["copy+paste"],
            display:
              localStorage.getItem(
                this.$store.state.company + "_" + "clipboard"
              ) !== "",
          },
          {
            name: i18n.t("common.add_exteral_link"),
            icon: "external-link",
            func: () => this.openRightSidebar("link", this.parentFolder),
            rights: ["edit_spaces"],
            display: true,
          },
          {
            name: i18n.t("files.delete_folder"),
            icon: "delete--alt",
            func: () => this.openRightSidebar("delete", this.parentFolder),
            rights: ["delete_folders"],
            display: true,
          },
        ],
        selection: [
          {
            name: i18n.t("files.move_selection"),
            icon: "move",
            func: () =>
              this.openRightSidebar("move", [
                ...this.filesSelected,
                ...this.foldersSelected,
              ]),
            rights: ["move_files", "move_folders"],
            display: true,
          },
          {
            name: i18n.t("files.copy_selection"),
            icon: "copy",
            func: () => this.copySelection(),
            rights: ["copy+paste"],
            display: true,
          },
          {
            name: i18n.t("files.delete_selection"),
            icon: "delete--alt",
            func: () =>
              this.openRightSidebar("delete", [
                ...this.filesSelected,
                ...this.foldersSelected,
              ]),
            rights: ["delete_files", "delete_folders"],
            display: true,
          },
        ],
        onlyFile: [
          {
            name: i18n.t("files.rename_file"),
            icon: "rename",
            func: () => this.openRightSidebar("rename", this.filesSelected[0]),
            rights: ["rename_files"],
            display: true,
          },
          {
            name: i18n.t("files.move_file"),
            icon: "move",
            func: () => this.openRightSidebar("move", this.filesSelected[0]),
            rights: ["move_files"],
            display: true,
          },
          {
            name: i18n.t("files.replace_file"),
            icon: "replace",
            func: () => this.openRightSidebar("replace", this.filesSelected[0]),
            rights: ["move_files"],
            display: true,
          },
          {
            name: i18n.t("files.copy_file"),
            icon: "copy",
            func: () => this.copySelection(),
            rights: ["copy+paste"],
            display: true,
          },
          {
            name: i18n.t("files.delete_file"),
            icon: "delete--alt",
            func: () => this.openRightSidebar("delete", this.filesSelected[0]),
            rights: ["delete_files"],
            display: true,
          },
        ],
        onlyFolder: [
          {
            name: i18n.t("files.rename_folder"),
            icon: "rename",
            func: () =>
              this.openRightSidebar("rename", this.foldersSelected[0]),
            rights: ["rename_folders"],
            display: true,
          },
          {
            name: i18n.t("files.move_folder"),
            icon: "move",
            func: () => this.openRightSidebar("move", this.foldersSelected[0]),
            rights: ["move_folders"],
            display: true,
          },
          {
            name: this.foldersSelected[0]
              ? !this.foldersSelected[0].private
                ? i18n.t("files.make_private")
                : i18n.t("files.make_public")
              : "",
            icon: "makeprivate",
            func: () => this.private(this.foldersSelected[0].id),
            rights: ["make-private_folders"],
            display: true,
          },
          {
            name: i18n.t("files.copy_folder"),
            icon: "copy",
            func: () => this.copySelection(),
            rights: ["copy+paste"],
            display: true,
          },
          {
            name: i18n.t("files.delete_folder"),
            icon: "delete--alt",
            func: () =>
              this.openRightSidebar("delete", this.foldersSelected[0]),
            rights: ["delete_folders"],
            display: true,
          },
        ],
      };
    },
    openRightSidebar(id, data) {
      EventBus.$emit(`right-sidebar-show`, {
        id: id,
        data: data,
      });
    },
    private(id, type) {
      let formData = new FormData();
      formData.append("folder", id);
      this.$axios.post(baseUrl + "/folderprivate", formData).then((r) => {
        EventBus.$emit("closeallactions");
        //refresh folders
        EventBus.$emit(`desktop-files-update`);
        EventBus.$emit(`tree-overview-reset`);
      });
    },
    pasteClipBoard() {
      paste(this, this.itemData.folderIds, true);
      /* if (this.pasting) {
        return;
      }*/

      /* if (
        localStorage.getItem(this.$store.state.company + "_" + "clipboard") !==
        ""
      ) {
        //this.pasting = true;

        //paste(this, this.itemData.folderIds, true)
        .then((response) => {
            this.pasting = false;
            EventBus.$emit("closeallactions");
            //refresh folders
            EventBus.$emit(`desktop-files-update`);
            EventBus.$emit(`tree-overview-reset`);

            //clear copy
            localStorage.setItem(
              this.$store.state.company + "_" + "clipboard",
              ""
            );
          })
          .catch((thrown) => {
            errorDispatch("error.collect_paste");

            this.pasting = false;

            EventBus.$emit("closeallactions");
            //refresh folders
            EventBus.$emit(`desktop-files-update`);
            EventBus.$emit(`tree-overview-reset`);

            //clear copy
            /*localStorage.setItem(
              this.$store.state.company + "_" + "clipboard",
              ""
            );*/
      /*  });
      } else {
        EventBus.$emit("closeallactions");
        //refresh folders
        EventBus.$emit(`desktop-files-update`);
        EventBus.$emit(`tree-overview-reset`);

        //clear copy
        localStorage.setItem(this.$store.state.company + "_" + "clipboard", "");
      }*/
    },
    copySelection() {
      copy(this, true);
    },

    actionHasRights(rights) {
      return userHasAllRights(rights, this);
    },
  },
};
